export const STATUSES = [
    { name: 'Inspected' },
    { name: 'Faulty' },
    { name: 'Draft' },
]

export const SYSTEM_STATUSES = [
    { name: 'Active' },
    { name: 'Inactive' }
]